import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import s from "../moreUser.module.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAppTranslation } from "./TranslationContext";
import { useTranslation } from 'react-i18next'; // i18next

export const MoreUser = () => {
  const { user } = useAuth();
  const { t } = useAppTranslation();
      const { i18n } = useTranslation();        // для переключения языка в i18next

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    til: '',
    ilmiy_daraja: '',
    otasining_ismi: '',
    description: '',
    id: ''
  });

  const [degrees, setDegrees] = useState([]); // список учёных степеней

  useEffect(() => {
    // Загружаем список учёных степеней
    const fetchDegrees = async () => {
      try {
        const res = await fetch('https://api.rasulova-academy.uz/api/ilmiy-darajalar/');
        const data = await res.json();
        setDegrees(data);
      } catch (err) {
        console.error('Ошибка при загрузке степеней:', err);
      }
    };

    fetchDegrees();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');

        const userRes = await fetch('https://api.rasulova-academy.uz/api/v1/dj-rest-auth/user/', {
          headers: { Authorization: `Token ${token}` },
        });
        let userData = await userRes.json();

        userData = { ...userData, id: userData.pk };
        delete userData.pk;

        const profileRes = await fetch(`https://api.rasulova-academy.uz/api/custom-users/?user=${userData?.id}`, {
          headers: { Authorization: `Token ${token}` },
        });
        const profileList = await profileRes.json();

        if (profileList.length === 0) {
          setFormData(prev => ({
            ...prev,
            first_name: userData.first_name || '',
            last_name: userData.last_name || '',
            til: '',
            ilmiy_daraja: '',
            otasining_ismi: '',
            description: '',
            id: null,
          }));
        } else {
          const profileData = profileList[0];
          setFormData({
            first_name: userData.first_name || '',
            last_name: userData.last_name || '',
            til: profileData.til?.toString() || '',
            ilmiy_daraja: profileData.ilmiy_daraja?.toString() || '',
            otasining_ismi: profileData.otasining_ismi || '',
            description: profileData.description || '',
            id: profileData.id,
          });
        }
      } catch (err) {
        toast.error('Ошибка при загрузке данных');
      }
    };

    fetchData();
  }, [user]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    if (!formData.id) {
      // Профиль не существует — создаём
      try {
        const createRes = await fetch(`https://api.rasulova-academy.uz/api/custom-users/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${token}`,
          },
          body: JSON.stringify({
            til: formData.til ? parseInt(formData.til) : null,
            ilmiy_daraja: formData.ilmiy_daraja ? parseInt(formData.ilmiy_daraja) : null,
            otasining_ismi: formData.otasining_ismi || '',
            description: formData.description || '',
            user: parseInt(user.id),
          }),
        });

        if (createRes.ok) {
          const newProfile = await createRes.json();
          setFormData(prev => ({ ...prev, id: newProfile.id }));
          toast.success("Профиль создан и сохранён!");
        } else {
          const errData = await createRes.json();
          toast.error(`Ошибка создания: ${JSON.stringify(errData)}`);
        }
      } catch (err) {
        toast.error("Ошибка при создании профиля.");
      }
      return;
    }

    // Обновление профиля
    try {
      await fetch('https://api.rasulova-academy.uz/api/v1/dj-rest-auth/user/', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify({
          first_name: formData.first_name,
          last_name: formData.last_name,
        }),
      });

      const res = await fetch(`https://api.rasulova-academy.uz/api/custom-users/${formData?.id}/`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify({
          til: formData.til ? parseInt(formData.til) : null,
          ilmiy_daraja: formData.ilmiy_daraja ? parseInt(formData.ilmiy_daraja) : null,
          otasining_ismi: formData.otasining_ismi || '',
          description: formData.description || '',
          user: parseInt(user.id) || null,
        }),
      });

      if (res.ok) {
        toast.success('Профиль успешно обновлён!');
      } else {
        const errData = await res.json();
        toast.error(`Ошибка: ${JSON.stringify(errData)}`);
      }
    } catch (err) {
      toast.error('Ошибка при обновлении данных');
    }
  };

  return (
    <div className={s.container}>
      <form onSubmit={handleSubmit}>
        <div className={s.wrapper}>
          <div className={s.registerBox}>
            <h2 className={s.title}>{t('moreTitle')}</h2>

            <label className={s.label} htmlFor="first_name">
              <span>{t('FirstName')}</span>
              <input
                name="first_name"
                placeholder={t('enterFirstName')}
                value={formData.first_name}
                onChange={handleChange}
                className={s.moreInput}
                required
              />
            </label>

            <label className={s.label} htmlFor="last_name">
              <span>{t('LastName')}</span>
              <input
                name="last_name"
                placeholder={t('enterLastName')}
                value={formData.last_name}
                onChange={handleChange}
                className={s.moreInput}
                required
              />
            </label>

            <label className={s.label}>
              <span>{t('Patronymic')}</span>
              <input
                name="otasining_ismi"
                placeholder={t('enterPatronymic')}
                value={formData.otasining_ismi}
                onChange={handleChange}
                className={s.moreInput}
              />
            </label>

            <label className={s.label}>
              <span>{t('language')}</span>
              <select name="til" value={formData.til} onChange={handleChange} required className={s.moreInput}>
                <option value="">{t('SelectLang')}</option>
                <option value="1">O'zbek</option>
                <option value="2">Русский</option>
                <option value="3">English</option>
              </select>
            </label>

            <label className={s.label}>
              <span>{t('AcadDegree')}</span>
              <select
                name="ilmiy_daraja"
                value={formData.ilmiy_daraja}
                onChange={handleChange}
                required
                className={s.moreInput}
              >
                <option value="">{t('enterAcadDegree')}</option>
                {degrees.map(degree => {
                  let name;
                  switch (i18n.language) {
                    case 'ru': name = degree.nomi_ru; break;
                    case 'en': name = degree.nomi_en; break;
                    default: name = degree.nomi_uz;
                  }
                  return (
                    <option key={degree.id} value={degree.id}>
                      {name}
                    </option>
                  );
                })}
              </select>
            </label>

            <label className={s.label}>
              <span>{t('about')}</span>
              <textarea
                name="description"
                placeholder={t('enterAbout')}
                value={formData.description}
                onChange={handleChange}
                className={s.moreInput}
              />
            </label>

            <div className={s.buttonGroup}>
              <button type="submit" className={s.loginBtn}>{t('save')}</button>
            </div>
          </div>
        </div>
      </form>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};
